// extracted by mini-css-extract-plugin
module.exports = {"actions":"CollectionsModalCreate-module_actions_2Xfyd","button":"CollectionsModalCreate-module_button_2Lw4U"};